
import { Vue, Component } from "vue-property-decorator";

@Component({ name: "icon-credit-card" })
export default class IconCreditCard extends Vue {}
